import { render, staticRenderFns } from "./SalesmanSaomaLog.vue?vue&type=template&id=47de4250&"
import script from "./SalesmanSaomaLog.vue?vue&type=script&lang=js&"
export * from "./SalesmanSaomaLog.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports